import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { src: String, srcset: String }

  connect() {
    if (!this.hasSrcValue) return
    if (!("IntersectionObserver" in window)) return this.load()

    const root = this.element.closest("[data-lazy-media-root]")
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load()
    }, { root, rootMargin: "300px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  load() {
    if (this.hasSrcsetValue) this.element.srcset = this.srcsetValue
    this.element.src = this.srcValue
    this.observer?.disconnect()
  }
}
